import styles from '@components/html/styles/Article.module.css'

const ViewContent = ({ content }) =>
    content
        ? <div className={styles.article} dangerouslySetInnerHTML={{ __html: content }} />
        : null

export default ViewContent